import { ethers } from 'ethers';
import { useState, useEffect } from 'react';

const DAIABI = require('./ABI/dai.json')['abi'];
const DAIAddress = '0x8e1CfDB1Dc8f1982c1D5F86DfF9c2f26817a9Abc';

const LINKABI = require('./ABI/erc20.json')['abi'];
const LINKAddress = '0x326C977E6efc84E512bB9C30f76E30c160eD06FB';

const DAIHandlerABI = require('./ABI/daimarket.json')['abi'];
const DAIMarketAddress = '0xFAD91bb06BC2d64fb06A1C68Cbd7ea0fE946ce4F';

const ETHHandlerABI = require('./ABI/ethmarket.json')['abi'];
const ETHMarketAddress = '0x2c5E1D834bf06aD6E396f598AF12D69f0697688F';

const LINKHandlerABI = require('./ABI/daimarket.json')['abi'];
const LINKMarketAddress =
  '0x7b953C9b425C73F82441AE46f6985Ca8D2808216';

const liqABI = require('./ABI/liq.json')['abi'];
const liqAddress = '0x20B73fE397bdB3CAd655055e3562C89CebA6fD23';

const ManagerABI = require('./ABI/manager.json')['abi'];
const ManagerAddress = '0x92E0c8B27760451aC9E8787679d50BfF01B43190';

function App() {
  const [userAccount, setuserAccount] = useState('');

  // price
  const [DAIPrice, setDAIPrice] = useState(0);
  const [ethPrice, setethPrice] = useState(0);
  const [linkPrice, setlinkPrice] = useState(0);

  // TOTAL VALUE LOCKED!
  const [totalValueLocked, settotalValueLocked] = useState(0);

  // userWallet DAI;
  const [userDAIBalance, setuserDAIBalance] = useState(0);
  const [userETHBalance, setuserETHBalance] = useState(0);
  const [userLINKBalance, setuserLINKBalance] = useState(0);

  //////////////////////////////////////////////////////////////////////////////////////////// DAI market details
  // user dai balance in dai market;
  const [userDAIBalanceInDAIMarket, setuserDAIBalanceInDAIMarket] =
    useState(0);
  // use borrowed dai balance in dai market;
  const [userDAIBorrowInDAIMarket, setuserDAIBorrowInDAIMarket] =
    useState(0);
  // total dai deposited in dai market;
  const [DAITotalDeposited, setDAITotalDeposited] = useState(0);
  // total dai borrowed from dai market;
  const [DAITotalBorrowed, setDAITotalBorrowed] = useState(0);
  // user withdrawable dai from dai market;
  const [DAIwithdrawableForUser, setDAIwithdrawableForUser] =
    useState(0);
  // user borroweable dai from dai market;
  const [DAIborroweableForUser, setDAIborroweableForUser] =
    useState(0);
  // repay of user to dai market;
  const [DAIRepayForUser, setDAIRepayForUser] = useState(0);

  const [DAISupplyRate, setDAISupplyRate] = useState(0);
  const [DAIBorrowRate, setDAIBorrowRate] = useState(0);

  //////////////////////////////////////////////////////////////////////////////////////////// LINK market details
  // user LINK balance in LINK market;
  const [
    userLINKBalanceInLINKMarket,
    setuserLINKBalanceInLINKMarket,
  ] = useState(0);
  // use borrowed LINK balance in LINK market;
  const [userLINKBorrowInLINKMarket, setuserLINKBorrowInLINKMarket] =
    useState(0);
  // total LINK deposited in LINK market;
  const [LINKTotalDeposited, setLINKTotalDeposited] = useState(0);
  // total LINK borrowed from LINK market;
  const [LINKTotalBorrowed, setLINKTotalBorrowed] = useState(0);
  // user withdrawable LINK from LINK market;
  const [LINKwithdrawableForUser, setLINKwithdrawableForUser] =
    useState(0);
  // user borroweable LINK from LINK market;
  const [LINKborroweableForUser, setLINKborroweableForUser] =
    useState(0);
  // repay of user to LINK market;
  const [LINKRepayForUser, setLINKRepayForUser] = useState(0);

  //////////////////////////////////////////////////////////////////////////////////////////// ETH market details
  // user ETH balance in ETH market;
  const [userETHBalanceInETHMarket, setuserETHBalanceInETHMarket] =
    useState(0);
  // use borrowed ETH balance in ETH market;
  const [userETHBorrowInETHMarket, setuserETHBorrowInETHMarket] =
    useState(0);
  // total ETH deposited in ETH market;
  const [ETHTotalDeposited, setETHTotalDeposited] = useState(0);
  // total ETH borrowed from ETH market;
  const [ETHTotalBorrowed, setETHTotalBorrowed] = useState(0);
  // user withdrawable ETH from ETH market;
  const [ETHwithdrawableForUser, setETHwithdrawableForUser] =
    useState(0);
  // user borroweable ETH from ETH market;
  const [ETHborroweableForUser, setETHborroweableForUser] =
    useState(0);
  // repay of user to eth market;
  const [ETHRepayForUser, setETHRepayForUser] = useState(0);

  const [ETHSupplyRate, setETHSupplyRate] = useState(0);
  const [ETHBorrowRate, setETHBorrowRate] = useState(0);

  //////////////////////////////////////////////////////////////////////////////////////////// form details
  const [amountToDepositDAI, setamountToDeposiDAI] = useState(0);
  const [amountToWithdrawDAI, setamountToWithdrawDAI] = useState(0);
  const [amountToBorrowDAI, setamountToBorrowDAI] = useState(0);
  const [amountToRepayDAI, setamountToRepayDAI] = useState(0);

  const [amountToDepositETH, setamountToDepositETH] = useState(0);
  const [amountToWithdrawETH, setamountToWithdrawETH] = useState(0);
  const [amountToBorrowETH, setamountToBorrowETH] = useState(0);
  const [amountToRepayETH, setamountToRepayETH] = useState(0);

  const [amountToDepositLINK, setamountToDepositLINK] = useState(0);
  const [amountToWithdrawLINK, setamountToWithdrawLINK] = useState(0);
  const [amountToBorrowLINK, setamountToBorrowLINK] = useState(0);
  const [amountToRepayLINK, setamountToRepayLINK] = useState(0);

  const [amountToGetLiquidate, setamountToGetLiquidate] = useState(0);
  const [ISUserOkForLiq, setISUserOkForLiq] = useState('');

  useEffect(() => {
    getMarketBalance();
    return () => {};
  });

  async function getMarketBalance() {
    // request accounts
    await requestAccounts();
    // create provider
    const provider = new ethers.providers.Web3Provider(
      window.ethereum
    );

    // get connected account !
    const accounts = await window.ethereum.request({
      method: 'eth_requestAccounts',
    });

    // create manager contract
    const ManagerContract = new ethers.Contract(
      ManagerAddress,
      ManagerABI,
      provider
    );
    // create dai market contract
    const DAIMarketContract = new ethers.Contract(
      DAIMarketAddress,
      DAIHandlerABI,
      provider
    );
    // create eth market contract
    const ETHMarketContract = new ethers.Contract(
      ETHMarketAddress,
      ETHHandlerABI,
      provider
    );

    // create LINK market contract
    const LINKMarketContract = new ethers.Contract(
      LINKMarketAddress,
      LINKHandlerABI,
      provider
    );
    //////////////////////////////// DAI
    // get user dai balance and borrow balance in dai market;
    const getDAIBalanceDetails = await DAIMarketContract.getAmounts(
      accounts[0]
    );

    // set total deposited dai in dai market;
    setDAITotalDeposited(getDAIBalanceDetails[0].toString());

    // set total borrowed dai in dai market;
    setDAITotalBorrowed(getDAIBalanceDetails[1].toString());

    //////////////////////////////// ETH
    // get user ETH balance and borrow balance in ETH market;
    const getETHBalanceDetails = await ETHMarketContract.getAmounts(
      accounts[0]
    );

    // set total deposited ETH in ETH market;
    setETHTotalDeposited(getETHBalanceDetails[0].toString());

    // set total borrowed ETH in ETH market;
    setETHTotalBorrowed(getETHBalanceDetails[1].toString());

    //////////////////////////////// LINK
    // get user LINK balance and borrow balance in LINK market;
    const getLINKBalanceDetails = await LINKMarketContract.getAmounts(
      accounts[0]
    );

    // set total deposited LINK in LINK market;
    setLINKTotalDeposited(getLINKBalanceDetails[0].toString());

    // set total borrowed LINK in LINK market;
    setLINKTotalBorrowed(getLINKBalanceDetails[1].toString());

    // get price;
    const DAIPrice = await ManagerContract.getUpdatedMarketTokenPrice(
      1
    );
    setDAIPrice(Number(DAIPrice) / 10 ** 18);

    const ethPrice = await ManagerContract.getUpdatedMarketTokenPrice(
      0
    );
    setethPrice(Number(ethPrice) / 10 ** 18);

    const linkPrice =
      await ManagerContract.getUpdatedMarketTokenPrice(2);
    setlinkPrice(Number(linkPrice) / 10 ** 18);

    const ETHValue =
      (Number(getETHBalanceDetails[0]) / 10 ** 18) *
      (Number(ethPrice) / 10 ** 18);

    const DAIValue =
      (Number(getDAIBalanceDetails[0]) / 10 ** 18) *
      (Number(DAIPrice) / 10 ** 18);

    const LinkValue =
      (Number(getLINKBalanceDetails[0]) / 10 ** 18) *
      (Number(linkPrice) / 10 ** 18);
    const totalValueLocked = ETHValue + DAIValue + LinkValue;
    settotalValueLocked(Number(totalValueLocked).toFixed(5));

    // get liq amount of user to get liquidate !
  }

  async function LoadAndCreate() {
    if (typeof window.ethereum !== 'undefined') {
      const accounts = await window.ethereum.request({
        method: 'eth_requestAccounts',
      });
      setuserAccount(accounts[0].toString());

      window.ethereum.on('chainChanged', (chainId) => {
        window.location.reload();
      });

      window.ethereum.on(
        'accountsChanged',
        async function (accounts) {
          setuserAccount(accounts[0].toString());
          await LoadAndCreate();
        }
      );
      const interval = setInterval(() => {
        getBalances();
      }, 5000);
      return () => clearInterval(interval);
    }
  }

  // request accounts from RPC
  async function requestAccounts() {
    await window.ethereum.request({
      method: 'eth_requestAccounts',
    });
  }

  // get balance of user
  async function getBalances() {
    // request accounts
    await requestAccounts();
    // create provider
    const provider = new ethers.providers.Web3Provider(
      window.ethereum
    );

    // get connected account !
    const accounts = await window.ethereum.request({
      method: 'eth_requestAccounts',
    });

    //////////////////////////////////////////////////////////////////////////////////////////// ** create contracts !
    // create DAI contract !
    const DAIContract = new ethers.Contract(
      DAIAddress,
      DAIABI,
      provider
    );

    // create LINK contract
    const LINKContract = new ethers.Contract(
      LINKAddress,
      LINKABI,
      provider
    );

    // create manager contract
    const ManagerContract = new ethers.Contract(
      ManagerAddress,
      ManagerABI,
      provider
    );

    // create manager contract
    const liqContract = new ethers.Contract(
      liqAddress,
      liqABI,
      provider
    );

    // create dai market contract
    const DAIMarketContract = new ethers.Contract(
      DAIMarketAddress,
      DAIHandlerABI,
      provider
    );
    // create eth market contract
    const ETHMarketContract = new ethers.Contract(
      ETHMarketAddress,
      ETHHandlerABI,
      provider
    );
    // create LINK market contract
    const LINKMarketContract = new ethers.Contract(
      LINKMarketAddress,
      LINKHandlerABI,
      provider
    );
    //////////////////////////////////////////////////////////////////////////////////////////// ** get wallet details !
    // get DAI balance of connected user;
    const userDAIBalance = await DAIContract.balanceOf(accounts[0]);
    setuserDAIBalance(userDAIBalance.toString());

    // get LINK balance of connected user;
    const userLINKBalance = await LINKContract.balanceOf(accounts[0]);
    setuserLINKBalance(userLINKBalance.toString());

    // get eth balance of connected user;
    const userETHBalance = await provider.getBalance(
      accounts[0].toString()
    );
    setuserETHBalance(userETHBalance.toString());

    //////////////////////////////////////////////////////////////////////////////////////////// ** get DAI market details !
    // get user dai balance and borrow balance in dai market;
    const getDAIBalanceDetails = await DAIMarketContract.getAmounts(
      accounts[0]
    );

    // set user dai  deposit in dai market as state;
    setuserDAIBalanceInDAIMarket(getDAIBalanceDetails[2].toString());

    // set user dai  borrow in dai market as state;
    setuserDAIBorrowInDAIMarket(getDAIBalanceDetails[3].toString());

    // // set total deposited dai in dai market;
    // setDAITotalDeposited(getDAIBalanceDetails[2].toString());

    // // set total borrowed dai in dai market;
    // setDAITotalBorrowed(getDAIBalanceDetails[3].toString());

    // get DAIwithdrawableForUser from dai market and update state;
    const DAIwithdrawableForUser =
      await DAIMarketContract.getUserMaxAmountToWithdraw(accounts[0]);

    // set DAIwithdrawableForUser as state
    setDAIwithdrawableForUser(DAIwithdrawableForUser.toString());

    // get DAIborroweableForUser from dai market;
    const DAIborroweableForUser =
      await DAIMarketContract.getUserMaxAmountToBorrow(accounts[0]);
    setDAIborroweableForUser(DAIborroweableForUser.toString());

    // get DAIRepayForUser from dai market;
    const DAIRepayForUser =
      await DAIMarketContract.getUserMaxAmountToRepay(accounts[0]);
    setDAIRepayForUser(DAIRepayForUser.toString());

    const DAISupplyRate =
      await DAIMarketContract.getUpdatedMarketSIRAndBIR();
    setDAISupplyRate(
      ethers.utils.formatUnits(DAISupplyRate[0].toString(), 16)
    );

    setDAIBorrowRate(
      ethers.utils.formatUnits(DAISupplyRate[1].toString(), 16)
    );
    //////////////////////////////////////////////////////////////////////////////////////////// ** get LINK market details !

    // get user LINK balance and borrow balance in LINK market;
    const getLINKBalanceDetails = await LINKMarketContract.getAmounts(
      accounts[0]
    );

    // set user LINK  deposit in LINK market as state;
    setuserLINKBalanceInLINKMarket(
      getLINKBalanceDetails[2].toString()
    );

    // set user LINK  borrow in LINK market as state;
    setuserLINKBorrowInLINKMarket(
      getLINKBalanceDetails[3].toString()
    );

    // // set total deposited LINK in LINK market;
    // setLINKTotalDeposited(getLINKBalanceDetails[2].toString());

    // // set total borrowed LINK in LINK market;
    // setLINKTotalBorrowed(getLINKBalanceDetails[3].toString());

    // get LINKwithdrawableForUser from LINK market and update state;
    const LINKwithdrawableForUser =
      await LINKMarketContract.getUserMaxAmountToWithdraw(
        accounts[0]
      );

    // set LINKwithdrawableForUser as state
    setLINKwithdrawableForUser(LINKwithdrawableForUser.toString());

    // get LINKborroweableForUser from LINK market;
    const LINKborroweableForUser =
      await LINKMarketContract.getUserMaxAmountToBorrow(accounts[0]);
    setLINKborroweableForUser(LINKborroweableForUser.toString());

    // get LINKRepayForUser from LINK market;
    const LINKRepayForUser =
      await LINKMarketContract.getUserMaxAmountToRepay(accounts[0]);
    setLINKRepayForUser(LINKRepayForUser.toString());

    //////////////////////////////////////////////////////////////////////////////////////////// ** get ETH market details !

    // get user ETH balance and borrow balance in ETH market;
    const getETHBalanceDetails = await ETHMarketContract.getAmounts(
      accounts[0]
    );

    // set user ETH  deposit in ETH market as state;
    setuserETHBalanceInETHMarket(getETHBalanceDetails[2].toString());

    // set user ETH  borrow in ETH market as state;
    setuserETHBorrowInETHMarket(getETHBalanceDetails[3].toString());

    // // set total deposited ETH in ETH market;
    // setETHTotalDeposited(getETHBalanceDetails[2].toString());

    // // set total borrowed ETH in ETH market;
    // setETHTotalBorrowed(getETHBalanceDetails[3].toString());

    // get ETHwithdrawableForUser from ETH market and update state;
    const ETHwithdrawableForUser =
      await ETHMarketContract.getUserMaxAmountToWithdraw(accounts[0]);

    // set ETHwithdrawableForUser as state
    setETHwithdrawableForUser(ETHwithdrawableForUser.toString());

    // get ETHborroweableForUser from ETH market;
    const ETHborroweableForUser =
      await ETHMarketContract.getUserMaxAmountToBorrow(accounts[0]);
    setETHborroweableForUser(ETHborroweableForUser.toString());

    // get ETHRepayForUser from ETH market;
    const ETHRepayForUser =
      await ETHMarketContract.getUserMaxAmountToRepay(accounts[0]);
    setETHRepayForUser(ETHRepayForUser.toString());

    const ETHSupplyRate =
      await ETHMarketContract.getUpdatedMarketSIRAndBIR();

    setETHSupplyRate(
      ethers.utils.formatUnits(ETHSupplyRate[0].toString(), 16)
    );

    setETHBorrowRate(
      ethers.utils.formatUnits(ETHSupplyRate[1].toString(), 16)
    );

    // how much remain for user to get liquidate ;
    const amountToGetLiquidate = await ETHMarketContract.connect(
      accounts[0]
    ).getUserLiquidationPrice();
    setamountToGetLiquidate(amountToGetLiquidate.toString());

    console.log(amountToGetLiquidate.toString());

    const ISUserOkForLiq = await liqContract.checkLiquidation(
      accounts[0]
    );
    setISUserOkForLiq(ISUserOkForLiq.toString());
  }

  const request100FreeDAI = async () => {
    await requestAccounts();
    const provider = new ethers.providers.Web3Provider(
      window.ethereum
    );
    const signer = provider.getSigner();

    const DAIContract = new ethers.Contract(
      DAIAddress,
      DAIABI,
      signer
    );

    const requestTX = await DAIContract.mintFreeDai();
    await requestTX.wait();
  };

  const depositInDaiMarket = async () => {
    const amountToDepositInWei = ethers.utils.parseEther(
      amountToDepositDAI.toString()
    );

    if (Number(amountToDepositInWei) <= Number(userDAIBalance)) {
      await requestAccounts();
      const provider = new ethers.providers.Web3Provider(
        window.ethereum
      );
      const signer = provider.getSigner();

      const DAIContract = new ethers.Contract(
        DAIAddress,
        DAIABI,
        signer
      );
      const DAIMarketContract = new ethers.Contract(
        DAIMarketAddress,
        DAIHandlerABI,
        signer
      );

      const ApproveTX = await DAIContract.approve(
        DAIMarketContract.address,
        amountToDepositInWei
      );
      await ApproveTX.wait();

      const DepositTX = await DAIMarketContract.deposit(
        amountToDepositInWei
      );
      await DepositTX.wait();

      console.log('DAI DEPOSITED');
      setamountToDeposiDAI(0);

      await getBalances();
    } else {
      alert('Low Balance');
      setamountToDeposiDAI(0);
    }
  };

  const withdrawFromDaiMarket = async () => {
    const amountToWithdrawInWei = ethers.utils.parseEther(
      amountToWithdrawDAI.toString()
    );

    if (
      Number(amountToWithdrawInWei) <= Number(DAIwithdrawableForUser)
    ) {
      await requestAccounts();
      const provider = new ethers.providers.Web3Provider(
        window.ethereum
      );
      const signer = provider.getSigner();

      const DAIMarketContract = new ethers.Contract(
        DAIMarketAddress,
        DAIHandlerABI,
        signer
      );

      const WithdrawTX = await DAIMarketContract.withdraw(
        amountToWithdrawInWei
      );
      await WithdrawTX.wait();

      console.log('DONE');
      setamountToWithdrawDAI(0);

      await getBalances();
    } else {
      alert('Low Balance');
      setamountToWithdrawDAI(0);
    }
  };

  const depositInLINKMarket = async () => {
    const amountToDepositInWei = ethers.utils.parseEther(
      amountToDepositLINK.toString()
    );

    if (Number(amountToDepositInWei) <= Number(userLINKBalance)) {
      await requestAccounts();
      const provider = new ethers.providers.Web3Provider(
        window.ethereum
      );
      const signer = provider.getSigner();

      const LINKContract = new ethers.Contract(
        LINKAddress,
        LINKABI,
        signer
      );

      const LINKMarketContract = new ethers.Contract(
        LINKMarketAddress,
        LINKHandlerABI,
        signer
      );

      const ApproveTX = await LINKContract.approve(
        LINKMarketContract.address,
        amountToDepositInWei
      );
      await ApproveTX.wait();

      const DepositTX = await LINKMarketContract.deposit(
        amountToDepositInWei
      );
      await DepositTX.wait();

      console.log('LINK DEPOSITED');
      setamountToDepositLINK(0);

      await getBalances();
    } else {
      alert('Low Balance');
      setamountToDepositLINK(0);
    }
  };

  const withdrawFromLINKMarket = async () => {
    const amountToWithdrawInWei = ethers.utils.parseEther(
      amountToWithdrawLINK.toString()
    );

    if (
      Number(amountToWithdrawInWei) <= Number(LINKwithdrawableForUser)
    ) {
      await requestAccounts();
      const provider = new ethers.providers.Web3Provider(
        window.ethereum
      );
      const signer = provider.getSigner();

      const LINKMarketContract = new ethers.Contract(
        LINKMarketAddress,
        LINKHandlerABI,
        signer
      );

      const WithdrawTX = await LINKMarketContract.withdraw(
        amountToWithdrawInWei
      );
      await WithdrawTX.wait();

      console.log('DONE');
      setamountToWithdrawLINK(0);

      await getBalances();
    } else {
      alert('Low Balance');
      setamountToWithdrawLINK(0);
    }
  };

  const depositInEthMarket = async () => {
    const amountToDepositETHInWei = ethers.utils.parseEther(
      amountToDepositETH.toString()
    );

    if (Number(amountToDepositETHInWei) <= Number(userETHBalance)) {
      await requestAccounts();
      const provider = new ethers.providers.Web3Provider(
        window.ethereum
      );
      const signer = provider.getSigner();

      const ETHMarketContract = new ethers.Contract(
        ETHMarketAddress,
        ETHHandlerABI,
        signer
      );

      const DepositTX = await ETHMarketContract.deposit(
        amountToDepositETHInWei,
        { value: amountToDepositETHInWei }
      );
      await DepositTX.wait();

      console.log('ETH DEPOSITED');
      setamountToDepositETH(0);

      await getBalances();
    } else {
      alert('Low Balance');
      setamountToDepositETH(0);
    }
  };

  const withdrawFromEthMarket = async () => {
    const amountToWithdrawETHInWei = ethers.utils.parseEther(
      amountToWithdrawETH.toString()
    );

    if (
      Number(amountToWithdrawETHInWei) <=
      Number(ETHwithdrawableForUser)
    ) {
      await requestAccounts();
      const provider = new ethers.providers.Web3Provider(
        window.ethereum
      );
      const signer = provider.getSigner();

      const ETHMarketContract = new ethers.Contract(
        ETHMarketAddress,
        ETHHandlerABI,
        signer
      );

      const WithdrawTX = await ETHMarketContract.withdraw(
        amountToWithdrawETHInWei
      );
      await WithdrawTX.wait();

      console.log('DONE');
      setamountToWithdrawETH(0);

      await getBalances();
    } else {
      alert('Low Balance');
      setamountToWithdrawETH(0);
    }
  };

  const borrowFromDaiMarket = async () => {
    const amountToBorrowInWei = ethers.utils.parseEther(
      amountToBorrowDAI.toString()
    );

    if (
      Number(amountToBorrowInWei) <= Number(DAIborroweableForUser)
    ) {
      await requestAccounts();
      const provider = new ethers.providers.Web3Provider(
        window.ethereum
      );
      const signer = provider.getSigner();

      const DAIMarketContract = new ethers.Contract(
        DAIMarketAddress,
        DAIHandlerABI,
        signer
      );

      const borrowTX = await DAIMarketContract.borrow(
        amountToBorrowInWei
      );
      await borrowTX.wait();

      console.log('DONE');
      setamountToBorrowDAI(0);

      await getBalances();
    } else {
      alert('Low Balance');
      setamountToBorrowDAI(0);
    }
  };

  const repayToDaiMarket = async () => {
    const amountToRepayInWei = ethers.utils.parseEther(
      amountToRepayDAI.toString()
    );

    if (Number(amountToRepayInWei) <= Number(DAIRepayForUser)) {
      await requestAccounts();
      const provider = new ethers.providers.Web3Provider(
        window.ethereum
      );
      const signer = provider.getSigner();

      const DAIContract = new ethers.Contract(
        DAIAddress,
        DAIABI,
        signer
      );
      const DAIMarketContract = new ethers.Contract(
        DAIMarketAddress,
        DAIHandlerABI,
        signer
      );

      const ApproveTX = await DAIContract.approve(
        DAIMarketContract.address,
        amountToRepayInWei
      );
      await ApproveTX.wait();

      const repayTX = await DAIMarketContract.repay(
        amountToRepayInWei
      );
      await repayTX.wait();

      console.log('DAI REPAYED');
      setamountToRepayDAI(0);

      await getBalances();
    } else {
      alert('Low Balance');
      setamountToRepayDAI(0);
    }
  };

  const borrowFromLINKMarket = async () => {
    const amountToBorrowInWei = ethers.utils.parseEther(
      amountToBorrowLINK.toString()
    );

    if (
      Number(amountToBorrowInWei) <= Number(LINKborroweableForUser)
    ) {
      await requestAccounts();
      const provider = new ethers.providers.Web3Provider(
        window.ethereum
      );
      const signer = provider.getSigner();

      const LINKMarketContract = new ethers.Contract(
        LINKMarketAddress,
        LINKHandlerABI,
        signer
      );

      const borrowTX = await LINKMarketContract.borrow(
        amountToBorrowInWei
      );
      await borrowTX.wait();

      console.log('DONE');
      setamountToBorrowLINK(0);

      await getBalances();
    } else {
      alert('Low Balance');
      setamountToBorrowLINK(0);
    }
  };

  const repayToLINKMarket = async () => {
    const amountToRepayInWei = ethers.utils.parseEther(
      amountToRepayLINK.toString()
    );

    if (Number(amountToRepayInWei) <= Number(LINKRepayForUser)) {
      await requestAccounts();
      const provider = new ethers.providers.Web3Provider(
        window.ethereum
      );
      const signer = provider.getSigner();

      const LINKContract = new ethers.Contract(
        LINKAddress,
        LINKABI,
        signer
      );
      const LINKMarketContract = new ethers.Contract(
        LINKMarketAddress,
        LINKHandlerABI,
        signer
      );

      const ApproveTX = await LINKContract.approve(
        LINKMarketContract.address,
        amountToRepayInWei
      );
      await ApproveTX.wait();

      const repayTX = await LINKMarketContract.repay(
        amountToRepayInWei
      );
      await repayTX.wait();

      console.log('LINK REPAYED');
      setamountToRepayLINK(0);

      await getBalances();
    } else {
      alert('Low Balance');
      setamountToRepayLINK(0);
    }
  };

  const borrowFromEthMarket = async () => {
    const amountToBorrowETHInWei = ethers.utils.parseEther(
      amountToBorrowETH.toString()
    );

    if (
      Number(amountToBorrowETHInWei) <= Number(ETHborroweableForUser)
    ) {
      await requestAccounts();
      const provider = new ethers.providers.Web3Provider(
        window.ethereum
      );
      const signer = provider.getSigner();

      const ETHMarketContract = new ethers.Contract(
        ETHMarketAddress,
        ETHHandlerABI,
        signer
      );

      const borrowTX = await ETHMarketContract.borrow(
        amountToBorrowETHInWei
      );
      await borrowTX.wait();

      console.log('DONE');
      setamountToBorrowETH(0);

      await getBalances();
    } else {
      alert('Low Balance');
      setamountToBorrowETH(0);
    }
  };

  const repayToETHMarket = async () => {
    const amountToRepayInETHWei = ethers.utils.parseEther(
      amountToRepayETH.toString()
    );

    if (Number(amountToRepayInETHWei) <= Number(ETHRepayForUser)) {
      await requestAccounts();
      const provider = new ethers.providers.Web3Provider(
        window.ethereum
      );
      const signer = provider.getSigner();

      const ETHMarketContract = new ethers.Contract(
        ETHMarketAddress,
        ETHHandlerABI,
        signer
      );

      const repayTX = await ETHMarketContract.repay(
        amountToRepayInETHWei,
        { value: amountToRepayInETHWei }
      );
      await repayTX.wait();

      console.log('ETH REPAYED');
      setamountToRepayETH(0);

      await getBalances();
    } else {
      alert('Low Balance');
      setamountToRepayETH(0);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          height: 300,
          width: '100%',
          backgroundColor: '#070A0E',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            alignItems: 'center',
            height: 200,
            width: 700,
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <div style={{ color: 'white', marginTop: 30 }}>
              {userAccount === '' ? (
                <button
                  style={{
                    fontSize: 25,
                    fontWeight: 50,
                    width: 500,
                    height: 75,
                  }}
                  onClick={() => LoadAndCreate()}
                >
                  Connect Your Wallet To Platform
                </button>
              ) : (
                userAccount
              )}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-around',
                alignItems: 'center',
                width: 1500,
                height: 100,
                marginTop: 26,
                borderColor: '#E0E0E0',
                borderRadius: 5,
                borderStyle: 'groove',
                paddingTop: 10,
                paddingBottom: 10,
                color: 'white',
                fontSize: 15,
                fontWeight: 50,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                }}
              >
                <div>ETH Market Total Deposited</div>
                <div>{Number(ETHTotalDeposited) / 10 ** 18}</div>
                <div style={{ marginTop: 10 }}>
                  ETH Supply Rate PERBLOCK :{' '}
                  {Number(ETHSupplyRate).toFixed(10)}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                }}
              >
                <div>ETH Market Total Borrowed</div>
                <div>{Number(ETHTotalBorrowed) / 10 ** 18}</div>
                <div style={{ marginTop: 10 }}>
                  ETH Borrow Rate PERBLOCK :{' '}
                  {Number(ETHBorrowRate).toFixed(10)}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                }}
              >
                <div>DAI Market Total Deposited</div>
                <div>{Number(DAITotalDeposited) / 10 ** 18}</div>
                <div style={{ marginTop: 10 }}>
                  DAI Supply Rate PERBLOCK :{' '}
                  {Number(DAISupplyRate).toFixed(10)}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                }}
              >
                <div>DAI Market Total Borrowed</div>
                <div>{Number(DAITotalBorrowed) / 10 ** 18}</div>
                <div style={{ marginTop: 10 }}>
                  DAI Borrow Rate PERBLOCK :{' '}
                  {Number(DAIBorrowRate).toFixed(10)}
                </div>
              </div>
            </div>
            <div
              style={{
                marginTop: 20,
                color: 'Highlight',
                fontSize: 30,
                fontWeight: 50,
              }}
            >
              Total Value Locked Around All Markets :
              {totalValueLocked} $
            </div>
          </div>
        </div>
      </div>
      {userAccount !== '' ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: 700,
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 30,
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <button
              style={{
                fontSize: 25,
                fontWeight: 50,
                width: 500,
                height: 75,
                backgroundColor: '#00D395',
                borderRadius: 10,
                borderColor: '#00D395',
              }}
              onClick={() => request100FreeDAI()}
            >
              Claim 1000 DAI Tokens
            </button>

            <div
              style={{
                marginTop: 10,
                fontSize: 20,
                color: 'GrayText',
              }}
            >
              You are in liquidation ? {ISUserOkForLiq} ,
              {(Number(amountToGetLiquidate) / 10 ** 18).toFixed(4)} $
              to Liquidate ;/
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around',
              alignItems: 'center',
              width: 1500,
              height: 150,
              backgroundColor: '#EEEEEE',
              marginTop: 26,
              borderColor: '#E0E0E0',
              borderRadius: 5,
              borderStyle: 'groove',
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              DEPOSIT DAI @ {DAIPrice.toFixed(4)} Per DAI
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <input
                  type="number"
                  value={amountToDepositDAI}
                  onChange={(e) =>
                    setamountToDeposiDAI(Number(e.target.value))
                  }
                ></input>
              </div>
              <button onClick={() => depositInDaiMarket()}>
                Deposit
              </button>
              <div style={{ marginTop: 10 }}>
                Wallet Balance :{' '}
                {(Number(userDAIBalance) / 10 ** 18).toFixed(4)}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              WITHDRAW DAI
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <input
                  type="number"
                  value={amountToWithdrawDAI}
                  onChange={(e) =>
                    setamountToWithdrawDAI(Number(e.target.value))
                  }
                ></input>
              </div>
              <button onClick={() => withdrawFromDaiMarket()}>
                Withdraw
              </button>
              <div style={{ marginTop: 10 }}>
                withdrawable DAI :
                {Number(DAIwithdrawableForUser) / 10 ** 18}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              BORROW DAI
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <input
                  type="number"
                  value={amountToBorrowDAI}
                  onChange={(e) =>
                    setamountToBorrowDAI(Number(e.target.value))
                  }
                ></input>
              </div>
              <button onClick={() => borrowFromDaiMarket()}>
                Borrow
              </button>
              <div style={{ marginTop: 10 }}>
                Borrowable DAI :
                {Number(DAIborroweableForUser) / 10 ** 18}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              REPAY DAI
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <input
                  type="number"
                  value={amountToRepayDAI}
                  onChange={(e) =>
                    setamountToRepayDAI(Number(e.target.value))
                  }
                ></input>
              </div>
              <button onClick={() => repayToDaiMarket()}>
                Repay
              </button>
              <div style={{ marginTop: 10 }}>
                Repay : {Number(DAIRepayForUser) / 10 ** 18}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              User Deposited
              <div style={{ marginTop: 10 }}>
                {(
                  Number(userDAIBalanceInDAIMarket) /
                  10 ** 18
                ).toFixed(4)}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              User Borrowed
              <div style={{ marginTop: 10 }}>
                {(
                  Number(userDAIBorrowInDAIMarket) /
                  10 ** 18
                ).toFixed(4)}
              </div>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around',
              alignItems: 'center',
              width: 1500,
              height: 150,
              backgroundColor: '#EEEEEE',
              marginTop: 26,
              borderColor: '#E0E0E0',
              borderRadius: 5,
              borderStyle: 'groove',
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              DEPOSIT ETH @ {ethPrice.toFixed(4)} Per ETH
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <input
                  type="number"
                  value={amountToDepositETH}
                  onChange={(e) =>
                    setamountToDepositETH(Number(e.target.value))
                  }
                ></input>
              </div>
              <button onClick={() => depositInEthMarket()}>
                Deposit
              </button>
              <div style={{ marginTop: 10 }}>
                Wallet Balance :{' '}
                {(Number(userETHBalance) / 10 ** 18).toFixed(4)}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              WITHDRAW ETH
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <input
                  type="number"
                  value={amountToWithdrawETH}
                  onChange={(e) =>
                    setamountToWithdrawETH(Number(e.target.value))
                  }
                ></input>
              </div>
              <button onClick={() => withdrawFromEthMarket()}>
                Withdraw
              </button>
              <div style={{ marginTop: 10 }}>
                withdrawable ETH :
                {Number(ETHwithdrawableForUser) / 10 ** 18}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              BORROW ETH
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <input
                  type="number"
                  value={amountToBorrowETH}
                  onChange={(e) =>
                    setamountToBorrowETH(Number(e.target.value))
                  }
                ></input>
              </div>
              <button onClick={() => borrowFromEthMarket()}>
                Borrow
              </button>
              <div style={{ marginTop: 10 }}>
                Borrowable ETH :
                {Number(ETHborroweableForUser) / 10 ** 18}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              REPAY ETH
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <input
                  type="number"
                  value={amountToRepayETH}
                  onChange={(e) =>
                    setamountToRepayETH(Number(e.target.value))
                  }
                ></input>
              </div>
              <button onClick={() => repayToETHMarket()}>
                Repay
              </button>
              <div style={{ marginTop: 10 }}>
                Repay : {Number(ETHRepayForUser) / 10 ** 18}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              User Deposited
              <div style={{ marginTop: 10 }}>
                {(
                  Number(userETHBalanceInETHMarket) /
                  10 ** 18
                ).toFixed(4)}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              User Borrowed
              <div style={{ marginTop: 10 }}>
                {(
                  Number(userETHBorrowInETHMarket) /
                  10 ** 18
                ).toFixed(4)}
              </div>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around',
              alignItems: 'center',
              width: 1500,
              height: 150,
              backgroundColor: '#EEEEEE',
              marginTop: 26,
              borderColor: '#E0E0E0',
              borderRadius: 5,
              borderStyle: 'groove',
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              DEPOSIT LINK @ {linkPrice.toFixed(4)} Per LINK
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <input
                  type="number"
                  value={amountToDepositLINK}
                  onChange={(e) =>
                    setamountToDepositLINK(Number(e.target.value))
                  }
                ></input>
              </div>
              <button onClick={() => depositInLINKMarket()}>
                Deposit
              </button>
              <div style={{ marginTop: 10 }}>
                Wallet Balance :
                {(Number(userLINKBalance) / 10 ** 18).toFixed(4)}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              WITHDRAW LINK
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <input
                  type="number"
                  value={amountToWithdrawLINK}
                  onChange={(e) =>
                    setamountToWithdrawLINK(Number(e.target.value))
                  }
                ></input>
              </div>
              <button onClick={() => withdrawFromLINKMarket()}>
                Withdraw
              </button>
              <div style={{ marginTop: 10 }}>
                withdrawable LINK :
                {Number(LINKwithdrawableForUser) / 10 ** 18}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              BORROW LINK
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <input
                  type="number"
                  value={amountToBorrowLINK}
                  onChange={(e) =>
                    setamountToBorrowLINK(Number(e.target.value))
                  }
                ></input>
              </div>
              <button onClick={() => borrowFromLINKMarket()}>
                Borrow
              </button>
              <div style={{ marginTop: 10 }}>
                Borrowable LINK :
                {Number(LINKborroweableForUser) / 10 ** 18}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              REPAY LINK
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                  marginBottom: 10,
                }}
              >
                <input
                  type="number"
                  value={amountToRepayLINK}
                  onChange={(e) =>
                    setamountToRepayLINK(Number(e.target.value))
                  }
                ></input>
              </div>
              <button onClick={() => repayToLINKMarket()}>
                Repay
              </button>
              <div style={{ marginTop: 10 }}>
                Repay : {Number(LINKRepayForUser) / 10 ** 18}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              User Deposited
              <div style={{ marginTop: 10 }}>
                {(
                  Number(userLINKBalanceInLINKMarket) /
                  10 ** 18
                ).toFixed(4)}
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              User Borrowed
              <div style={{ marginTop: 10 }}>
                {(
                  Number(userLINKBorrowInLINKMarket) /
                  10 ** 18
                ).toFixed(4)}
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
}

export default App;
